var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStocqClockIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200.48 124.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        stroke: #5349b7;\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-4 {\n        stroke: #c1c4c6;\n      }\n\n      .cls-26 {\n        opacity: .25;\n      }\n\n      .cls-5 {\n        fill: #5349b7;\n      }\n\n      .cls-6 {\n        fill: #7a78f4;\n      }\n\n      .cls-7 {\n        fill: #88909f;\n      }\n\n      .cls-8 {\n        fill: #6d6ae5;\n      }\n\n      .cls-9 {\n        fill: #9b9bce;\n      }\n\n      .cls-10 {\n        fill: #8383b7;\n      }\n\n      .cls-11 {\n        fill: #3f3c9e;\n      }\n\n      .cls-12 {\n        fill: #252568;\n      }\n\n      .cls-13 {\n        fill: #d3d7df;\n      }\n\n      .cls-14 {\n        fill: #c0bfef;\n      }\n\n      .cls-15 {\n        fill: #bdbbff;\n      }\n\n      .cls-16 {\n        fill: #cdd0da;\n      }\n\n      .cls-17 {\n        fill: #b8b8f4;\n      }\n\n      .cls-18 {\n        fill: #9d8abc;\n      }\n\n      .cls-19 {\n        fill: #333387;\n      }\n\n      .cls-20 {\n        fill: #fff;\n      }\n\n      .cls-21 {\n        fill: #edeff7;\n      }\n\n      .cls-22 {\n        fill: #e5e5e5;\n      }\n\n      .cls-23 {\n        fill: #f4f4f4;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 200.48,
    height: 124.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 200.48,
    height: 124.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.81,
    y: 58.86,
    width: 42.82,
    height: 48.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13628",
    "data-name": "Group 13628"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11358",
    "data-name": "Group 11358"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7263",
    "data-name": "Rectangle 7263",
    className: "cls-2",
    x: 0.48,
    y: 0,
    width: 200,
    height: 124
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11357",
    "data-name": "Group 11357"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11356",
    "data-name": "Group 11356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27186",
    "data-name": "Path 27186",
    className: "cls-21",
    d: "M25.61,110.54c-4.35-15.01-6.56-30.55-6.58-46.18.16-25.12,17.08-40.94,34.83-44.84,35.41-7.78,48.67,5.81,62.69,19.4,8.53,8.62,19.69,14.15,31.72,15.72,11.87,1.5,19.79-1.41,27.81,2.08,2.18.95,6.94,3.49,9.01,11.33,4.3,16.29-10.11,35.02-16.86,42.49H25.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7264",
    "data-name": "Rectangle 7264",
    className: "cls-13",
    x: 24.08,
    y: 110.34,
    width: 146.03,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27187",
    "data-name": "Path 27187",
    className: "cls-21",
    d: "M100.58,16.99c-.02,2.03,5.07,1.94,12.51,7.53s6.69,8.94,13.32,14.86c2.43,2.17,11.09,9.89,23.16,9.88,1.5,0,15.12-.15,17.79-6.83,3.39-8.47-11.48-25.8-29.21-31.22-18.07-5.52-37.52,1.82-37.57,5.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27188",
    "data-name": "Path 27188",
    className: "cls-16",
    d: "M93,58.86h44.32c1.28,0,2.31,1.03,2.31,2.31v50.59c0,1.28-1.03,2.31-2.31,2.31h-44.32c-1.28,0-2.31-1.03-2.31-2.31v-50.59c0-1.28,1.03-2.31,2.31-2.31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11355",
    "data-name": "Group 11355",
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11354",
    "data-name": "Group 11354"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11353",
    "data-name": "Group 11353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27189",
    "data-name": "Path 27189",
    className: "cls-7",
    d: "M137.32,58.86h-40.51v45.39c0,1.74,1.41,3.16,3.15,3.16,0,0,0,0,.01,0h39.66v-46.24c0-1.28-1.03-2.31-2.31-2.31Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_27190",
    "data-name": "Path 27190",
    className: "cls-7",
    d: "M101.24,60.07h27.84c.63,0,1.13.51,1.13,1.14s-.51,1.13-1.13,1.13h-27.84c-.63,0-1.14-.51-1.14-1.13s.51-1.14,1.14-1.14h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7266",
    "data-name": "Rectangle 7266",
    className: "cls-23",
    x: 101.52,
    y: 25.05,
    width: 27.08,
    height: 36.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27191",
    "data-name": "Path 27191",
    className: "cls-22",
    d: "M128.59,61.21h-27.07V25.05l27.07,36.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7267",
    "data-name": "Rectangle 7267",
    className: "cls-4",
    x: 104.39,
    y: 28.89,
    width: 21.34,
    height: 29.98,
    rx: 1.03,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    className: "cls-4",
    x1: 115.16,
    y1: 28.89,
    x2: 115.06,
    y2: 58.86
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    className: "cls-4",
    x1: 104.39,
    y1: 35.33,
    x2: 125.73,
    y2: 35.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    className: "cls-4",
    x1: 104.39,
    y1: 41.18,
    x2: 125.73,
    y2: 41.18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_388",
    "data-name": "Line 388",
    className: "cls-4",
    x1: 104.39,
    y1: 47.1,
    x2: 125.73,
    y2: 47.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_389",
    "data-name": "Line 389",
    className: "cls-4",
    x1: 104.39,
    y1: 52.98,
    x2: 125.73,
    y2: 52.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27192",
    "data-name": "Path 27192",
    className: "cls-20",
    d: "M114.39,70.6c9.57,0,17.33,7.76,17.33,17.33s-7.76,17.33-17.33,17.33-17.33-7.76-17.33-17.33,7.76-17.33,17.33-17.33h0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3821",
    "data-name": "Ellipse 3821",
    className: "cls-3",
    cx: 114.55,
    cy: 87.65,
    r: 17.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27193",
    "data-name": "Path 27193",
    className: "cls-15",
    d: "M114.72,87.73l8.82,10.85c5.99-4.87,6.91-13.68,2.04-19.67-4.87-5.99-13.68-6.91-19.67-2.04-5.99,4.87-6.91,13.68-2.04,19.67,2.64,3.25,6.6,5.15,10.79,5.17l.06-13.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27194",
    "data-name": "Path 27194",
    className: "cls-5",
    d: "M114.55,86.06c.88,0,1.59.71,1.59,1.59s-.71,1.59-1.59,1.59-1.59-.71-1.59-1.59h0c0-.88.71-1.59,1.59-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27195",
    "data-name": "Path 27195",
    className: "cls-5",
    d: "M114.73,100.16h0c-.51,0-.92-.41-.92-.92v-10.39c0-.51.41-.92.92-.92.51,0,.92.41.92.92v10.39c0,.51-.41.92-.92.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27196",
    "data-name": "Path 27196",
    className: "cls-5",
    d: "M119.58,94.11h0c-.4.31-.98.23-1.29-.18l-3.6-4.74c-.3-.41-.22-.98.19-1.29.4-.3.96-.22,1.27.17l3.6,4.74c.31.4.23.98-.18,1.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27197",
    "data-name": "Path 27197",
    className: "cls-17",
    d: "M68.2,108.46v-.94l2.17-.45.54,1.44-.37.6-2.34-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27198",
    "data-name": "Path 27198",
    className: "cls-8",
    d: "M65.35,113.72c-.08.34-.14.68-.18,1.03-.02.28.1.56.32.74.32.24.71.39,1.12.41.57.08,1.14.06,1.7-.05.43-.14.83-.35,1.19-.62.24-.27.38-.62.4-.98,0-.36-.11-.67.21-.92s.89-.58,1.02-.71c.15-.13.22-.32.2-.52-.03-.12-.07-.24-.12-.36l-2.8,1.96-3.05.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27199",
    "data-name": "Path 27199",
    className: "cls-8",
    d: "M68.1,108.98c-.02-.24-.01-.48.04-.72.42-.07.85-.05,1.27.05.32.08,1.02.36,1.02.36l.28.15c.16-.19.18-.46.04-.66-.06-.11-.29-.59-.29-.59.04-.09.13-.14.22-.12.16.03.43.48.45.71.05.25.07.5.07.75-.07.36-.16.72-.28,1.07l-2.83,4.2-1.87-1.09.7-1.63,1.18-2.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27200",
    "data-name": "Path 27200",
    className: "cls-17",
    d: "M79.06,110.52l.68-.63,2.65.44.05.85-2.94,1.83-.76-1.14.32-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27201",
    "data-name": "Path 27201",
    className: "cls-8",
    d: "M78.04,114.53c-.06.22-.08.46-.07.69.29.61.86,1.05,1.53,1.17.76.05,1.49.3,2.13.71.42.52.91.98,1.46,1.36.68.35,1.43.55,2.2.6.58-.04,1.16-.13,1.72-.27.24-.08.46-.21.65-.38v-1.18l-9.63-2.7h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27202",
    "data-name": "Path 27202",
    className: "cls-8",
    d: "M79.06,110.52c.09.39.25.77.46,1.11.19.13.48-.02.67-.06s1.08-.32,1.48-.41.74-.2.74-.2l.26.9,2.94,3.49-2.6.28-4.28-3.37.32-1.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27203",
    "data-name": "Path 27203",
    className: "cls-19",
    d: "M64.88,78.11s.19,7.32.42,8.56.76,3.09.76,3.82-.16,3.61-.26,4.52c-.22,1.67-.19,3.36.1,5.02.41,1.37.75,2.76,1.02,4.16.12.92.34,2.06.34,2.4v.78c.34.26.72.46,1.13.58.57.08,1.14-.02,1.65-.28.24-.19.43-.44.55-.72-.08-.27-.14-.54-.17-.82-.04-.39-.32-3.39-.33-4.08s.28-2.71.3-3.42-.22-2.39-.23-2.75c0-.24-.04-.47-.08-.7.24-.53.41-1.08.51-1.65.03-.3.03-.61,0-.91,0,0,.67-2.96.71-3.62s.74-5.29.95-6.07,1.44-4.74,1.44-4.74l-8.82-.1v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27204",
    "data-name": "Path 27204",
    className: "cls-12",
    d: "M65.29,86.67c.22,1.24.76,3.09.76,3.82s-.16,3.61-.26,4.52c-.22,1.67-.19,3.35.1,5.01.41,1.37.75,2.76,1.02,4.16.12.92.34,2.06.34,2.4v.78c.24.17.49.33.75.46.01-.87.02-2.12-.01-2.91-.05-1.29-.81-5-.88-6.87s.04-7.55,0-9.63-.55-9.49-.55-9.49l-.07-.81-1.62-.02s.19,7.32.42,8.56v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27205",
    "data-name": "Path 27205",
    className: "cls-19",
    d: "M71.89,76.85s2.99,7.86,3.72,9.56,2.66,5.89,2.86,6.93c.25,1.02.36,2.06.34,3.11-.19,1.42-.21,2.85-.07,4.27.27.93.44,1.89.5,2.86-.03.62,0,4.05,0,4.05v2.34c.31.29.7.48,1.12.56.64.08,1.29.08,1.93,0,.14-.09.37-.29.34-.52-.02-.15-.05-.3-.1-.44l.61-5.57s.59-5.15.57-5.91-.32-2.01-.3-2.62c.15-1.2.17-2.41.04-3.61-.17-.7-.21-1.43-.11-2.14,0-.72-.53-4.91-.75-5.88s-1.41-4.84-1.66-5.41-1.23-3.33-1.23-3.33l-7.82,1.75h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27206",
    "data-name": "Path 27206",
    className: "cls-12",
    d: "M80.37,110.53c.64.08,1.29.08,1.93,0,.14-.09.37-.29.34-.52-.02-.15-.05-.3-.1-.44l.61-5.57s.59-5.15.57-5.91-.32-2.01-.3-2.62c.01-.43.15-1.73.15-2.69-.84.54-1.86.73-2.84.52-.98-.41-1.95-2.69-2.46-4.5-.39-1.39-2.4-9.15-3.3-12.64l-3.08.69s2.99,7.86,3.72,9.55,2.66,5.89,2.86,6.93c.25,1.02.37,2.06.34,3.11-.19,1.42-.21,2.85-.07,4.27.27.93.44,1.89.5,2.86-.03.62,0,4.05,0,4.05v2.34c.31.29.7.48,1.12.56h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27207",
    "data-name": "Path 27207",
    className: "cls-9",
    d: "M61.09,65.51s.1,2.82.13,3.4.11,2.6.21,3.17.75,3.17.97,3.89.7,2.65.74,2.88c0,.24.05.48.13.71.15.29.27.6.35.92,0,.16-.04,2.5-.03,2.62.2.51.44,1.01.73,1.48.04,0,.09,0,.13,0,0,0,.11.24.17.36.06.13.14.24.25.33.07.02.15.03.22.03.05.07.09.14.12.22.04.12.08.2.2.2s.38.08.51.08.67.04.67.04l-1.39-5.53-1.62-8.51-.63-7.37-1.84,1.07h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27208",
    "data-name": "Path 27208",
    className: "cls-18",
    d: "M66.57,85.86l-.47-1.89-.44-1.26h-.34s-.49-.01-.42.24.61,1.29.67,1.62c.05.24.08.48.08.73,0,.12-.1.33-.03.48.1.02.19.04.29.05.13,0,.67.04.67.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27209",
    "data-name": "Path 27209",
    className: "cls-17",
    d: "M64.53,65.29s.17,1.73.17,2.28v2.23s.21,1.71.19,2.42c.08,1.76.25,3.52.52,5.26.22.86.53,1.69.91,2.49.32.34.59.72.8,1.13.17.29.32.6.44.92,0,.26.02.52.07.78.1.19.17.39.21.6-.02.32,0,.63.07.94.07.15.09.32.06.49-.03.1-.45.17-.69-.22-.2-.41-.34-.84-.4-1.29-.03-.18-.1-.35-.2-.5-.04-.02-.1-.06-.1-.06,0,0-.06.88-.05,1.09.06.39.13.77.23,1.15.13.28.27.55.44.8.14.16.23.35.28.55,0,0,.02.34-.22.31s-.55-.51-.77-.69-.54-.45-.54-.45c0,0-.25-.92-.34-1.22s-.44-1.11-.44-1.11c-.34-.58-.56-1.22-.65-1.88-.07-.94-.23-2.92-.36-3.38-.28-1.07-.64-2.11-1.08-3.12-.52-1.3-.91-2.65-1.15-4.03-.18-.95-.32-1.91-.4-2.88.03-.84.13-1.67.31-2.49l2.68-.11h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27210",
    "data-name": "Path 27210",
    className: "cls-10",
    d: "M97.72,44.01l.85-1.17,1.18-.05.38.47-.48,1.85-1.34.48-.59-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27211",
    "data-name": "Path 27211",
    className: "cls-9",
    d: "M99.09,42.09l1.41.74c.4.21.39.25.37.4-.11.29-.31.53-.56.7-.41.21-.83.39-1.26.54,0,0-.4-.06-.21-.31s.39-.56.5-.72l.11-.16-.8-.32.45-.86h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27212",
    "data-name": "Path 27212",
    className: "cls-9",
    d: "M100.55,44.6c.07.09.07.22.01.32-.13.18-.33.3-.55.34-.27.07-1.16.21-1.16.21,0,0-.39-.36.03-.49.34-.1.69-.18,1.04-.24l.62-.14h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27213",
    "data-name": "Path 27213",
    className: "cls-17",
    d: "M88.39,52.27s2.38-.18,2.63-.11c0,0,.34.08.44-.09.38-.78.85-1.51,1.39-2.19.51-.5.95-1.07,1.28-1.7.23-.47,1.27-2.39,1.44-2.76.35-.62.75-1.22,1.18-1.79.37-.56.79-1.09,1.23-1.59.68-.42,1.39-.8,2.12-1.14.45-.07.91-.09,1.36-.08.7,0,1.06.02.99.21-.22.29-.56.48-.92.51-.44.03-.88.13-1.29.31-.27.11-.5.28-.68.5-.09.25-.2.49-.32.72-.17.26-.51.3-.61.47s-.18.29-.18.29c0,0-.17,1.15.21,1.29.3.1.6.18.91.23-.3.34-.64.64-1.01.9-.46.27-.76.37-.97.66s-2.01,4.55-2.6,5.57-1.86,3.78-2.43,3.88-1.98,0-3.09,0c-.86.02-3.29.09-3.29.09l1.62-3.84.6-.36h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27214",
    "data-name": "Path 27214",
    className: "cls-17",
    d: "M97.72,44.01s1.67-.28,2.07-.34c.36-.06.72-.06,1.08-.02.18.13.25.35.18.56-.2.25-.47.43-.77.54-.28.08-.56.12-.85.14,0,0-.44,0-.73,0s-.43.26-.68.25-.64-.25-.64-.54c0-.25.14-.48.35-.61h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27215",
    "data-name": "Path 27215",
    className: "cls-17",
    d: "M99.14,44.89c-.07-.13-.73-.24-.74-.43-.07-.14-.15-.28-.24-.41l-.14-.1-1.36-.22c-.4.54-.77,1.1-1.1,1.68-.02.04-.05.1-.09.17l.69.31c.33.14.69.18,1.04.14.24-.03,1.01-.14,1.24-.75.04-.11.23-.33.69-.41v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27216",
    "data-name": "Path 27216",
    className: "cls-9",
    d: "M97.38,46.02c.25-.01.49-.08.71-.2l.19-.23c-.4.22-.88.25-1.3.08-.45-.23-.65-.78-.44-1.25.09-.34.37-.59.72-.64l-.59-.04c-.4.54-.77,1.1-1.1,1.68-.02.04-.05.1-.09.17l.69.31c.33.14.69.18,1.04.14.05,0,.11-.01.16-.03h.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27217",
    "data-name": "Path 27217",
    className: "cls-9",
    d: "M91.52,53.17c.32-.76.71-1.5,1.15-2.2.48-.67,1.59-2.27,1.93-2.92.22-.55.39-1.13.5-1.71-.37.69-.82,1.55-.97,1.84-.33.63-.77,1.2-1.28,1.7-.55.67-1.02,1.4-1.42,2.17-.1.17-.44.09-.44.09-.25-.07-.3.25-.3.25.12.24.21.49.27.75.06.34.39.39.56.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27218",
    "data-name": "Path 27218",
    className: "cls-12",
    d: "M86.35,56.27l2.16.09c0,.21-.1.41-.25.56-.2.23-.48.38-.79.41-.35-.1-.68-.27-.96-.5l-.16-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27219",
    "data-name": "Path 27219",
    className: "cls-11",
    d: "M80.97,50.35c.28-.11.3.05,1.4.46.07.03.56.19,1.53.53.92.32,1.38.47,1.63.54.69.2,1.41.3,2.13.31.49,0,.95-.05.97.03s-.36.12-.69.41c-.09.07-.32.29-.57,1.11-.28.91-.08.91-.34,1.71-.09.37-.17.74-.22,1.11-.03.1-.02.21.01.31.09.19.28.33.49.35.52.07.95-.56,1.04-.48.05.04-.02.23-.15.38-.36.4-1.05.26-1.18.24-.23-.07-.46-.16-.69-.26-.4-.09-.81-.07-1.2.05-.73.18-1.47.28-2.19.45-1.51.36-2.26.54-2.61.35-1.19-.61-.73-3.28-.21-6.29.08-.54.4-1.02.86-1.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27220",
    "data-name": "Path 27220",
    className: "cls-11",
    d: "M60.91,56.76s-.27,1.78-.44,2.97-.29,3.08-.48,4.03-.38,1.86-.38,1.86c.47.17.96.28,1.45.34.58.03,1.91.22,2.49.22s1.98-.21,1.98-.21c0,0,.22-5.88-.21-7.12s-2.27-2.26-2.27-2.26l-2.15.15v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27221",
    "data-name": "Path 27221",
    className: "cls-5",
    d: "M66.75,50.2c-.25.02-.49.11-.69.27-.38.28-2,1.42-2,1.42l-1.76,1.08s.63,2.49,1.18,4.12c.54,1.46.95,2.97,1.22,4.5-.11,1.33-.09,2.67.05,4,.43,1.65.74,3.33.91,5.02-.03,1.07-.52,4.65-.47,6.19.06,1.09.25,2.17.55,3.22,0,0,5.95-.57,7.07-.83,2.4-.88,4.76-1.9,7.05-3.04.44-.21.9-.37,1.37-.47.48-.05.24-7.13,0-10.45s-.62-9.74-.52-11.16.48-3.75.48-3.75c-.81-.07-1.63-.09-2.45-.06-.58.14-1.18.17-1.77.08-.42-.16-2.1-.88-2.1-.88l-8.1.75h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27222",
    "data-name": "Path 27222",
    className: "cls-6",
    d: "M76.11,49.99c-.6-.25-1.26-.53-1.26-.53l-8.1.75c-.25.02-.49.11-.69.27-.13.1-.42.3-.73.52.43.49.94.91,1.51,1.23.48.3,1,.54,1.54.71,1.09.39,2.27.47,3.41.23,1.07-.24,2.05-.77,2.85-1.52.57-.47,1.06-1.03,1.46-1.65h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27223",
    "data-name": "Path 27223",
    className: "cls-14",
    d: "M68.27,44.76c-.17.51.25.79.33,2.15.05.46.03.92-.08,1.37-.18.71-.6,1.33-1.2,1.76-.6.39-1.04.3-1.1.54-.09.38.94,1.01,1.82,1.34,1.48.59,3.12.58,4.59-.02.89-.42,1.63-1.1,2.13-1.94.18-.33.11-.46.08-.5-.11-.16-.43-.05-.74-.29-.06-.05-.12-.11-.17-.17-.36-.44-.26-1.89-.29-2.44-.12-1.21-.89-2.27-2.01-2.75-1.31-.52-3.08.07-3.37.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27224",
    "data-name": "Path 27224",
    className: "cls-9",
    d: "M73.72,48.31c-.08-.6-.05-1.38-.07-1.75-.12-1.21-.89-2.27-2.01-2.75-1.31-.52-3.08.07-3.37.95-.17.51.25.79.33,2.15,0,.11,0,.22.02.33.89.56,1.9.92,2.95,1.03.7.21,1.45.22,2.15.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27225",
    "data-name": "Path 27225",
    className: "cls-17",
    d: "M73.39,38.42c.44.38.76.87.95,1.42.05.17.07.32.19.71.17.57.26.67.31.95.09.47-.11.49-.08,1.05.03.49.17.52.19,1.05.01.35-.05.39-.05.79,0,.33.04.65.11.97.02.14.2,1.35-.24,1.85-.19.21-.65.47-2.34.02-1.99-.53-3.58-.96-4.85-2.53-.51-.63-2.05-2.54-1.34-4.65.91-2.28,3.5-3.38,5.78-2.47.5.2.96.49,1.36.86v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27226",
    "data-name": "Path 27226",
    className: "cls-9",
    d: "M74.91,44.39c0-.4.06-.44.05-.79-.02-.52-.16-.56-.19-1.05-.03-.56.17-.57.08-1.05-.09-.32-.19-.64-.31-.95-.12-.39-.14-.54-.19-.71-.05-.16-.11-.31-.19-.45.13.53.1,1.08-.09,1.59-.13.35-.28.52-.24.85.1.53.37,1.02.76,1.4.04.04.13.1.13.2,0,.18-.27.24-.33.46-.04.17.07.29.17.5.12.31.16.63.13.96.04.43.16.85.36,1.23.05-.4.05-.81-.01-1.21-.07-.32-.1-.64-.11-.97h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27227",
    "data-name": "Path 27227",
    className: "cls-12",
    d: "M73.37,38.41c-1.13-1.01-2.68-1.38-4.14-1.01-1.35.37-2.45,1.34-2.98,2.64-.71,2.11.83,4.02,1.34,4.65h.01l1.87-1.49c.15-.12.2-.32.13-.49l-.45-1.12.61-.67-.43-1.18c-.05-.13,0-.28.13-.34.49-.26,1-.47,1.52-.63.38-.1,1.48-.26,2.39-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27228",
    "data-name": "Path 27228",
    className: "cls-14",
    d: "M66.94,43.09c-.18-.05-.71-.19-.91.06-.27.33.23,1.09.27,1.15.32.47,1.03,1.11,1.62.87.24-.1.41-.3.48-.55.14-.64-.71-1.33-1.45-1.53h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27229",
    "data-name": "Path 27229",
    className: "cls-5",
    d: "M62.3,52.97c-.46.39-.78.91-.92,1.5-.41,1.21-.13,1.22-.48,2.04-.09.15-.12.33-.08.5.14.33.77.33,1.04.35,1.54.12,2.07,1.67,2.55,1.48.86-.34.17-5.64-1.39-5.92-.23-.1-.49-.09-.71.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27230",
    "data-name": "Path 27230",
    className: "cls-11",
    d: "M65.19,67.59s.58-4.31,1.3-5.55,1.41-2.63,1.41-2.63l.57-1.19s-1.07,3.18-1.36,4.49c-.29,1.31-1.71,5.92-1.71,5.92l-.21-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27231",
    "data-name": "Path 27231",
    className: "cls-11",
    d: "M75.95,73.83c.65-2.01,1.17-4.06,1.58-6.14.3-2.1,1.45-10.09,1.45-10.09,0,0,.61-4.74.61-5.47v-1.27s-.29,5.96-.39,7.35-.6,6.79-.92,7.98-2.32,7.64-2.32,7.64h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27232",
    "data-name": "Path 27232",
    className: "cls-11",
    d: "M78.62,75.1c-.81.26-3.03,1.74-4.01,2.2-1.32.49-2.71.74-4.11.74-1.17-.02-2.51-.96-2.51-1.29-.07-.87-.04-1.74.07-2.6.4-1.18.88-2.32,1.43-3.44.19-.6,1.12-2.46,1.12-2.46l-2.9,5.4s.13-1.53.13-2.36.07-2.32.07-3.4c.37-2,.87-3.98,1.5-5.91-.77,1.66-1.43,3.37-1.98,5.11-.07.81-.17,3.25-.17,4.44-.13.89-.58,1.69-1.27,2.27l-.63-.15c-.13,1.05-.19,2.11-.19,3.17.07,1.09.25,2.17.55,3.22,0,0,5.95-.57,7.07-.83,2.4-.88,4.76-1.9,7.05-3.04.44-.21.9-.37,1.37-.47.12-.01.19-.45.23-1.14-.95.13-1.89.32-2.82.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27233",
    "data-name": "Path 27233",
    className: "cls-5",
    d: "M79.27,110.33c-.19.38-.27.8-.23,1.22.14.43.44.69.55.65s-.28-.22.33-.41.73-.43,1.17-.11,3.07,3.51,3.07,3.51h1.05l-2.15-2.48-.54-.8-.1-.92v-.22l.43,1.13s1.35,1.78,1.78,2.2,1.95,1.73,2.25,1.99c.35.32.62.72.77,1.17.08.36-.23.4-.84.51-1.27.22-2.58.06-3.77-.46-.81-.55-1.67-1.01-2.58-1.37-.76-.26-1.51-.59-2.22-.97-.22-.16-.23-.37-.15-.75s.51-2.5.51-2.84-.17-.55.01-.77c.19-.15.42-.24.66-.26v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27234",
    "data-name": "Path 27234",
    className: "cls-8",
    d: "M80.85,111.98c.14,0,.26.12.26.26,0,.14-.12.26-.26.26-.14,0-.26-.12-.26-.26,0-.14.11-.26.26-.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27235",
    "data-name": "Path 27235",
    className: "cls-8",
    d: "M81.67,113.08c.14,0,.26.12.26.26,0,.14-.12.26-.26.26-.14,0-.26-.12-.26-.26,0-.14.11-.26.26-.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27236",
    "data-name": "Path 27236",
    className: "cls-8",
    d: "M82.67,114.27c.14,0,.26.12.26.26,0,.14-.12.26-.26.26-.14,0-.26-.12-.26-.26,0-.14.11-.26.26-.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27237",
    "data-name": "Path 27237",
    className: "cls-5",
    d: "M66.14,112.17c.32-.45,1.04-1.66,1.23-2.03.2-.39.38-.8.52-1.22.04-.14.1-.28.17-.41,0,0,.54.35.52.61s-1.44,2.87-1.51,3.01c-.07.12-.03.27.09.34.03.02.06.03.1.03.38.03.75.03,1.13,0,0,0,.17-.02.19-.25s.77-2.25.88-2.48.88-1.23.88-1.23c.17-.02.34.06.45.2.19.24.43.28.47.69s.02,2.48.02,2.48c0,0-.48.37-.73.6s-.29.22-.43.52c-.17.44-.4.85-.68,1.23-.42.36-.92.6-1.46.71-.58,0-1.17-.05-1.74-.17-1.75-.38-.42-2.19-.1-2.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27238",
    "data-name": "Path 27238",
    className: "cls-8",
    d: "M70.4,109.48c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27239",
    "data-name": "Path 27239",
    className: "cls-8",
    d: "M69.61,110.8c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27240",
    "data-name": "Path 27240",
    className: "cls-8",
    d: "M69.04,112.1c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27241",
    "data-name": "Path 27241",
    className: "cls-8",
    d: "M68.08,109.1c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27242",
    "data-name": "Path 27242",
    className: "cls-8",
    d: "M67.56,110.31c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27243",
    "data-name": "Path 27243",
    className: "cls-8",
    d: "M66.74,111.83c.1,0,.19.09.19.19,0,.1-.09.19-.19.19-.1,0-.19-.09-.19-.19s.09-.19.19-.19h0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocqClockIn);
export default __webpack_public_path__ + "static/media/stocq-clock-in.7560117014506149113233b775f95767.svg";
export { ForwardRef as ReactComponent };